import appApis from '@/store/apis/app';
import { APP_QUERY_TAG } from '@/store/apis/app';
import { CategoryStatus, IAppCategory } from '@/types/api/app/category';
import { FilterBuilder, WhereBuilder } from '@loopback/filter';

const appCategoriesApis = appApis.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<IAppCategory[], { name?: string }>({
      query: ({ name }) => {
        const filterBuilder = new FilterBuilder();
        const whereBuilder = new WhereBuilder();

        whereBuilder.ilike('status', CategoryStatus.Active);

        if (name) {
          whereBuilder.ilike('title', name);
        }

        const where = whereBuilder.build();
        filterBuilder.where(where);

        const filter = filterBuilder.build();

        return {
          url: '/categories',
          method: 'GET',
          params: {
            filter: JSON.stringify(filter),
          },
        };
      },
      providesTags: (result = []) => {
        if (!result) {
          return [{ type: APP_QUERY_TAG.categories, id: '*' }];
        }
        return [
          { type: APP_QUERY_TAG.categories, id: '*' },
          ...result.map(
            ({ id }) => ({ type: APP_QUERY_TAG.categories, id } as const)
          ),
        ];
      },
      transformResponse: (response: IAppCategory[]) => {
        if (!response) return [];
        return response;
      },
    }),

    getCategoryDetails: build.query<IAppCategory, { categorySlug: string }>({
      query: ({ categorySlug }) => {
        return {
          url: `/categories/slugs/${categorySlug}`,
          method: 'GET',
        };
      },
      providesTags: [APP_QUERY_TAG.categoryDetails],
    }),
  }),
});

export const { useGetCategoriesQuery, useGetCategoryDetailsQuery } =
  appCategoriesApis;

export default appCategoriesApis;
